import type { Router } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

export function registerGuard(router: Router) {
  router.beforeEach(async () => {

    const authStore = useAuthStore();

    if (!authStore.ready) {
      await authStore.init();
    }

    if (!authStore.isAuthenticated) {
      authStore.login();
    }

    return true;
  });
}
